<template>
  <div>
    <logged-in-header />
    <contact />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import contact from "../components/contact/ContactForm";

export default {
  components: {
    loggedInHeader,
    contact
  }
};
</script>
